var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 42.9688H49.2188V28.9062L39.8438 25.7812L36.7188 14.8438H21.0938V42.9688H2.34375V25.7812",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 42.9688H25.7812",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0312 49.2188C35.483 49.2188 38.2812 46.4205 38.2812 42.9688C38.2812 39.517 35.483 36.7188 32.0312 36.7188C28.5795 36.7188 25.7812 39.517 25.7812 42.9688C25.7812 46.4205 28.5795 49.2188 32.0312 49.2188Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3438 21.0938V25.7812H33.5938",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 17.9687L7.3 13.0125",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 14.8438C15.1705 14.8438 17.9688 12.0455 17.9688 8.59375C17.9688 5.14197 15.1705 2.34375 11.7188 2.34375C8.26697 2.34375 5.46875 5.14197 5.46875 8.59375C5.46875 12.0455 8.26697 14.8438 11.7188 14.8438Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truck-icon.1f1ec5f74ff484146a943d33c03b2e5a.svg";
export { ForwardRef as ReactComponent };